var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17539 5.23334V4.58573C2.17539 2.43316 3.88146 0.700012 6.00039 0.700012C7.32032 0.700012 8.48004 1.37253 9.16698 2.40001M2.17539 5.23334C1.47414 5.23334 0.900391 5.8162 0.900391 6.52858V13.0048C0.900391 13.7172 1.47414 14.3 2.17539 14.3H9.82539C10.5266 14.3 11.1004 13.7172 11.1004 13.0048V6.52858C11.1004 5.8162 10.5266 5.23334 9.82539 5.23334H2.17539ZM6.00039 8.47144C6.70164 8.47144 7.27539 9.0543 7.27539 9.76668C7.27539 10.4791 6.70164 11.0619 6.00039 11.0619C5.29914 11.0619 4.72539 10.4791 4.72539 9.76668C4.72539 9.0543 5.29914 8.47144 6.00039 8.47144Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockBlack);
export default __webpack_public_path__ + "static/media/unlock_black.98a5aeff1c283950dd4d1f3809ed45d8.svg";
export { ForwardRef as ReactComponent };